module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av749-06780f6e055fc09027b4f3e72fe5c0a7.jpg";